import { QUERY_KEYS } from "@/libraries/constant";
import type { PayloadCreateEvent, PayloadUpdateEvent } from "@/types";
import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

function useEventMutation() {
	const create = useMutation<any, AxiosError, PayloadCreateEvent>({
		mutationKey: [QUERY_KEYS.MUTATE_EVENT_CREATE],
	});

	const update = useMutation<any, AxiosError, PayloadUpdateEvent>({
		mutationKey: [QUERY_KEYS.MUTATE_EVENT_UPDATE],
	});

	const remove = useMutation<any, AxiosError, number>({
		mutationKey: [QUERY_KEYS.MUTATE_EVENT_REMOVE],
	});

	const copy = useMutation<any, AxiosError, PayloadUpdateEvent>({
		mutationKey: [QUERY_KEYS.MUTATE_EVENT_COPY],
	});

	return { create, update, remove, copy };
}

export default useEventMutation;
